import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AuthService } from '@s-services/auth.service';
import { CompanyService } from '@s-services/company.service';
import { CompanyProgressService } from '@s-services/company-progress.service';

import {
  LucideAngularModule,
  BarChart2,
  GitBranch,
  Settings,
  Gauge,
  Droplet,
  Stethoscope,
  Calendar,
  Users,
  Route,
  Bell,
  CalendarCheck,
  Clock,
  Contact,
  Briefcase,
  Layers,
  Building2,
  Mail,
  LogOut,
  Star,
} from 'lucide-angular';

import { HlmSidebarImports } from '@spartan-ng/helm/sidebar';
import { HlmSeparator } from '@spartan-ng/helm/separator';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { DisplayProfileImgComponent } from '@s-components/display-profile-img/display-profile-img.component';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  imports: [
    CommonModule,
    RouterModule,
    LucideAngularModule,
    ...HlmSidebarImports,
    HlmSeparator,
    ...HlmDropdownMenuImports,
    DisplayProfileImgComponent,
  ],
})
export class SidenavComponent {
  readonly GaugeIcon = Gauge;
  readonly DropletIcon = Droplet;
  readonly StethoscopeIcon = Stethoscope;
  readonly GitBranchIcon = GitBranch;
  readonly CalendarIcon = Calendar;
  readonly UsersIcon = Users;
  readonly RouteIcon = Route;
  readonly BellIcon = Bell;
  readonly CalendarCheckIcon = CalendarCheck;
  readonly ClockIcon = Clock;
  readonly ContactIcon = Contact;
  readonly BriefcaseIcon = Briefcase;
  readonly SettingsIcon = Settings;
  readonly LayersIcon = Layers;
  readonly BarChart2Icon = BarChart2;
  readonly Building2Icon = Building2;
  readonly MailIcon = Mail;
  readonly LogOutIcon = LogOut;
  readonly StarIcon = Star;

  constructor(
    public authService: AuthService,
    public companyService: CompanyService,
    public companyProgress: CompanyProgressService,
  ) {}

  onLogout() {
    this.authService.logout();
  }
}
